import { render, staticRenderFns } from "./PageErrorNotFound.vue?vue&type=template&id=77fdf3e1&"
import script from "./PageErrorNotFound.vue?vue&type=script&lang=js&"
export * from "./PageErrorNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports